import { makeStyles } from 'tss-react/mui';

export const useBarChartWidgetStyles = makeStyles({ name: 'BarChartWidget' })(
  theme => ({
    root: {
      padding: theme.spacing(6),
      paddingBottom: theme.spacing(14),
    },
    title: {
      display: 'flex',
      marginBottom: theme.spacing(5),
    },
  }),
);
